import {gsap} from "gsap";
import {checkDeviceMobile} from "../../../libs/helper";

export class ElementLinkUnderlineItem {
    constructor({el, isEvent = true}) {
        this.DOM = {el};

        this.DOM.el.classList.add('linkNone', 'is-handler');
        this.DOM.spanIcon = document.createElement('span');
        this.DOM.spanIcon.classList.add('linkNone_line');

        this.DOM.spanIcon2 = document.createElement('span');
        this.DOM.spanIcon2.classList.add('linkNone_line');

        this.DOM.el.append(this.DOM.spanIcon);
        this.DOM.el.append(this.DOM.spanIcon2);

        if (isEvent)
            this.bindEvent();
    }


    onHover() {

        gsap.killTweensOf([this.DOM.spanIcon, this.DOM.spanIcon2]);

        gsap.fromTo(this.DOM.spanIcon, {x: '0%'}, {
            x: '102%', duration: .5, ease: 'power3.out'
        });
        gsap.fromTo(this.DOM.spanIcon2, {x: '-102%'}, {
            x: '0%', duration: .5, ease: 'power3.out',
            delay: .2
        });
    }

    bindEvent() {
        if (!checkDeviceMobile()) this.DOM.el.addEventListener('mouseenter', this.onHover.bind(this));
    }
}